import React, { Key, ReactElement, ReactNode, useState } from 'react'

interface TabProps {
  label: string
  children: ReactNode
}

const Tab = ({ children }: TabProps): JSX.Element => {
  return <>{children}</>
}

interface TabsProps {
  classes: string
  children: ReactNode
  tabClass?: string
  tabButtonClass?: string
  active?: number
  onTabChange?: (index: number, key: Key|null) => void
}

const Tabs = ({ classes, children, tabClass = 'col-md-3', tabButtonClass = 'button-tab', active = 0, onTabChange }: TabsProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(active)
  const tabArray = React.Children.toArray(children).filter(
      (child): child is ReactElement<TabProps> =>
        React.isValidElement(child) && 'label' in child.props
    )

  const handleTabChange = (index: number, key: Key|null) => {
    setActiveTab(index)
    if(onTabChange) {
      onTabChange(index, key)
    }
  };

  return (
    <div className={classes}>
      <div className="tabs flex-container header-step-button-container">
        {tabArray.map((child, index) => (
          <div key={child.key} className={tabClass}>
            <button key={index} onClick={() => handleTabChange(index, child.key)}
                    className={`button ${tabButtonClass} button--width-full ${index === activeTab ? `${tabButtonClass}--active` : ''}`}>
              {(child as ReactElement<TabProps>).props.label}
            </button>
          </div>
        ))}
      </div>
      <div className="tab-content">
        {tabArray[activeTab]}
      </div>
    </div>
  )
}

const TabsLikeWizard = ({ classes, children }: TabsProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0)

  const tabArray = React.Children.toArray(children).filter(
    (child): child is ReactElement<TabProps> =>
      React.isValidElement(child) && 'label' in child.props
  )

  return (
    <div className={classes}>
      <div className="tabs wizzard-inner u-pointer">
        {tabArray.map((child, index) => (
          <div key={`tab-wizzard-${index}`} className={`wizzard__step wizzard__step--no-mt ${index === activeTab ? 'wizzard__step--active' : ''}`}
               onClick={() => setActiveTab(index)}>
            <div className="step__progression">
              <div className="progress"/>
            </div>
            <div className="step__number">{index + 1 < 10 ? `0${index + 1}` : index + 1}</div>
            <div className="step__title">{(child as ReactElement<TabProps>).props.label}</div>
          </div>
        ))}
      </div>
      <div className="tab-content">
        {tabArray[activeTab]}
      </div>
    </div>
  )
}

export {
  Tab,
  Tabs,
  TabsLikeWizard
}
